import icons from "../../icons";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { loginFunc } from "../../services/authApiRoutes/APImethods";
import { useDispatch } from 'react-redux';
import $ from 'jquery';
import { loginSessionDetail } from '../../redux/reducers/LoginSessionSlice';
import Cookies from 'universal-cookie';
import { logError } from "../../services/authApiRoutes/APImethods";
import {setCalendarDateRange} from '../../redux/reducers/CalendarRangeSlice';
import Constants from '../../Constants';

const LoginForm = React.forwardRef((prop, ref) => {
  const cookies = new Cookies();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loginErrorMessage, setLoginErrorMessage] = useState("")

  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "onSubmit" });

  const onFormSubmit = (data) => {
    const params = {
      email: data.email.toLowerCase(),
      password: data.password
    }
    loginFunc(params).then(response => {
      if (response.data.msg === "login successful") { 
        dispatch(setCalendarDateRange(Constants.DEFAULT_DATE_RANGE));
        var userInfo = response.data.userInfo.data
        localStorage.setItem('role', JSON.stringify(userInfo.role));
        cookies.set('userEmail', userInfo.email, { path: '/' });
        cookies.set('i18nextLng', userInfo.locale, { path: '/' });
        dispatch(loginSessionDetail(userInfo))
        navigate("/home");
      }else if(response.data.msg === "user locked"){
        if(response.data.userInfo.profileIncomplete){
          navigate("/unauth/verify-newuser?id="+response?.data?.userInfo?.random);
        }
      } else {
        setLoginErrorMessage(response.data.msg)
      }
    }).catch((err) => {
      if(err?.response?.status!==403){
        const errorMessage = "Error while login. Reason:";
        logError(errorMessage,err.message );  
      }
    })

  };
  const handleError = (errors) => { };

  const validationRules = {
    email: {
      required: `${t('email_validation.required')}`,
      pattern: {
        value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: `${t('email_validation.format')}`,
      }

    },
    password: {
      required: `${t('password_validation.required')}`,
    }
  };

  useEffect(()=>{
    setTimeout(() => {
      $('#inputEmail').trigger('focus');
    }, 300);
  }, []);
  
  return (
    <div>
      <form onSubmit={handleSubmit(onFormSubmit, handleError)}>

        {
          ((errors?.email?.message || errors?.password?.message) || loginErrorMessage) !== ''
            ?
            <p className="error" aria-label="error alert" role="alert">
              {errors?.email && errors.email.message}
              <br />
              {errors?.password && errors.password.message}
              {loginErrorMessage}
            </p>
            : ''}

        <div className="input-group">
          <span className="input-group-text">
            <img src={icons.EMAIL_ICON} alt="Email Icon" />
          </span>
          <input
            id="inputEmail"
            type="email"
            className="form-control"
            placeholder={t('email')}
            aria-required="true"
            name="email"
            ref={ref}
            {...register('email', validationRules.email)}
          />
        </div>
        <div className="input-group last">
          <span className="input-group-text">
            <img src={icons.PASSWORD_ICON} alt="Password Icon" />
          </span>
          <input
            type="Password"
            className="form-control"
            placeholder={t('password')}
            name="password"
            aria-required="true"
            {...register('password', validationRules.password)}
          />
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            name="checkbox"
            value=""
            id="customCheckbox"
          />
          <label className="form-check-label" htmlFor="customCheckbox">
            {t('remember_me')}
          </label>
        </div>
        <div className="form-button">
          <button type="submit" className="btn">
            {t('login')}
          </button>
        </div>
        <div className="forget-pass">
          <Link to="/forgot-password">{t('forgot_password')}</Link>
        </div>
        <div className="or">
          <span>{t('or')}</span>
        </div>
        <div className="form-button">
          <button type="button" className="btn btn-secondary" onClick={() => { navigate("/sso") }}>
            {t('oranization_sign_in')}
          </button>
        </div>
      </form>
    </div>
  );
});

export default LoginForm;
